import React from 'react';
import { connect } from 'react-redux';
import { callService, goTo } from '../tools';

import Datos from './datos.cmpt';
import Seguridad from './seguridad.cmpt';
import ContratoMedios from './contrato-medios.cmpt';
import ContratoDatos from './contrato-datos.cmpt';
import LoSentimos from './lo-sentimos.cmpt';
import Bienvenido from '../contrato/bienvenido.cmpt';

const mapState = (state) => {
	return {
		paso: state.registroAF.paso,
		uid: state.global.uid,
		tid: state.global.tid 
	};
}

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "ERROR", "mensaje" : sMensaje, "accion" : fnCerrar});
		},
		siguientePaso: () => {
			dispatch({ "type": "REGISTRO_FAMILIAR_PASO", "paso": 0 });
		},
		loginAccesoFamiliar: (sEmail) => {
            dispatch({ "type": "LOGIN_SET_ACCESO_FAMILIAR", "accesoFamiliar": sEmail});
        },
		altaHash: (hashOne, hashTwo, sEmail) => {
			dispatch({ "type": "REGISTRO_FAMILIAR_HASH", "hashOne": hashOne, "hashTwo": hashTwo});
			dispatch({ "type": "REGISTRO_FAMILIAR_EMAIL", "email": sEmail });
		}
	}
}

class Flujo extends React.Component {
	
    login = () => {
    	this.props.loginAccesoFamiliar(this.props.email);
    	goTo("login?accesoFamiliar=" + this.props.email);
    	//window.location.href = '/#!/login?accesoFamiliar='+this.props.email;
    }
	
	cerrar = () => {
		goTo("login");
		//window.location.href = '/#!/';	
	}
	
	componentWillMount = () => {
		let $this = this;
		
		$this.props.loader(true);
		$this.props.siguientePaso();
		
		if(this.props.hashOne && this.props.hashTwo && this.props.email) {
			$this.props.altaHash(this.props.hashOne, this.props.hashTwo, this.props.email);
			let llamaServicio = new callService({
				service: 'accesoFamiliar.validarInvitacion',
				secure: true,
				data: {
					hashOne: this.props.hashOne,
					hashTwo: this.props.hashTwo,
					email: this.props.email
				}
			}).execute().then((respuesta) => {
				console.log("Respuesta", respuesta);
				$this.props.loader(false);
			}).catch((error) => {
				console.log("Error", error);
				$this.props.loader(false);
				$this.props.alerta(error.message.mensaje, $this.cerrar);
			});
		} else {
			$this.props.loader(false);
			$this.props.alerta("La liga no puede ser procesada", $this.cerrar);
		}
	}

	render() {
		return (
			<div className="login-wrap">
				<div className="container">
					<div className="ayuda-wrap">
						<p>¿Tienes duda de cómo utilizar el portal? <a href="">Ver tutorial</a></p>
					</div>
					<div className="login-box">
						{ this.props.paso == 0 && 
							<Datos />
						}
						{ this.props.paso == 1 && 
							<Seguridad />
						}
						{ this.props.paso == 2 && 
							<ContratoMedios />
						}
						{ this.props.paso == 3 && 
							<ContratoDatos />
						}
						{ this.props.paso == 4 && 
							<LoSentimos />
						}
						{ this.props.paso == 5 && 
							<Bienvenido />
						}
					</div>
				</div>
			</div>
		)
	}
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/registro-familiar/flujo.cmpt.js